import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import { DynamicLogo } from "../DynamicLogo";

export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 100);
    };

    let ticking = false;
    const throttledHandleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', throttledHandleScroll, { passive: true });
    return () => window.removeEventListener('scroll', throttledHandleScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: [0.4, 0, 0.2, 1], delay: 0.2 }}
      className={`fixed top-0 z-50 w-full transition-all duration-500 ease-out ${isScrolled
        ? 'bg-slate-900/95 backdrop-blur-xl border-b border-cyan-400/20 shadow-2xl shadow-black/30'
        : 'bg-gradient-to-b from-black/20 via-black/10 to-transparent border-b border-transparent'
        }`}
    >
      <div className={`container flex items-center justify-between transition-all duration-500 ${isScrolled ? 'h-16 lg:h-18' : 'h-20 lg:h-24'
        }`}>
        <Link to="/" className="flex items-center group">
          <DynamicLogo
            area="header"
            alt="Portal do Cliente"
            className={`h-12 w-auto transition-all duration-300 group-hover:scale-105 ${isScrolled ? 'drop-shadow-lg' : 'drop-shadow-2xl'
              }`}
            fallback={
              <div className="h-12 w-28 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-lg flex items-center justify-center text-white font-bold text-sm">
                LOGO
              </div>
            }
          />
        </Link>
      </div>
    </motion.header>
  );
}
